import LogoSantaraDark from 'assets/images/backoffice/capital/logo-santara-dark.png';
import NewBadge from 'assets/images/backoffice/capital/new-badge.png';
import React from 'react';
import Button from '../Button';
import CategoryBorder from './CategoryBorder';
import styles from './ProductCard.css';

function InvestmentProduct() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <CategoryBorder color="green" />
        <img src={NewBadge} className={styles['new-badge']} />
        <p className={styles.title}>Investment</p>
        <div className={`${styles['logo-wrapper']} ${styles.investment}`}>
          <img className={styles['invest-logo']} src={LogoSantaraDark} />
        </div>
        <p className={styles.desc}>
          Dapatkan pendanaan hingga Rp10 miliar untuk ekspansi bisnis dari
          40.000 investor terpercaya melalui platform crowdfunding.
        </p>
        <div className={styles['action-wrapper']}>
          <Button title="Akan Datang" disabled />
        </div>
        <a
          className={styles.link}
          href="https://www.mokapos.com/invest-id"
          target="_blank"
        >
          Pelajari lebih lanjut
        </a>
      </div>
    </div>
  );
}

export default InvestmentProduct;
